module.exports = __webpack_public_path__ + "img/nav03.0db59b47.png";